// Redux
import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { StripeInfo } from "interfaces/shared/userInfo";

// Types
import type { RootState, UserInfoSlice } from "redux/types";

// Defaults
export const initialState: UserInfoSlice = {
    htmlHeader: "",
    htmlFooter: "",
    stripeActive: []
};

// Slice
export const userInfoSlice = createSlice({
    name: "USER_INFO",
    initialState,
    reducers: {
        setHtmlHeader: (state, action: PayloadAction<string>) => {
            return { ...state, htmlHeader: action.payload };
        },
        setHtmlFooter: (state, action: PayloadAction<string>) => {
            return { ...state, htmlFooter: action.payload };
        },
        setStripeActive: (state, action: PayloadAction<StripeInfo[]>) => {
            return { ...state, stripeActive: action.payload };
        },
    }
});

// Actions
export const { setHtmlHeader, setHtmlFooter, setStripeActive } = userInfoSlice.actions;

// Selector
export const htmlHeaderSelector = (state: RootState): string => state.userInfo.htmlHeader;
export const htmlFooterSelector = (state: RootState): string => state.userInfo.htmlFooter;
export const stripeActiveSelector = (state: RootState): StripeInfo[] => state.userInfo.stripeActive;

// Reducers
export default userInfoSlice.reducer;
